import { useState, useEffect } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';
import { apiEndpoints } from '../utils/api';

/**
 * Custom hook to check API health status at regular intervals
 * @param {number} interval - The interval in milliseconds between checks
 * @returns {Object} Object containing health status and last check timestamp
 */
const useApiHealth = (interval = 5000) => {
  const authenticatedApi = useAuthenticatedApi();
  const [isHealthy, setIsHealthy] = useState(false);
  const [lastChecked, setLastChecked] = useState(null);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        await authenticatedApi.get(apiEndpoints.health);
        setIsHealthy(true);
        setLastChecked(new Date());
        return true;
      } catch (error) {
        console.error('Health check failed:', error);
        setIsHealthy(false);
        setLastChecked(new Date());
        return false;
      }
    };

    // Initial check
    checkHealth();
    
    // Set up interval for periodic checks
    const intervalId = setInterval(checkHealth, interval);
    
    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, [interval]);

  return { isHealthy, lastChecked };
};

export default useApiHealth; 